import { Component, OnInit } from "@angular/core";
import { UsrCred } from "src/app/models/usrcred";
import { VproService } from "src/app/service/vpro/vpro.service";
import { Utils } from "src/app/common/utils";
//import { Router } from '@angular/router';

const DISABLED_MENUS = [5, 6, 7, 8, 11, 31, 20, 21, 22, 23]
const SIDE_MENUS = {

  admindashboard: {
    id: 2,
    title: "Admin dashboard",
    link: "/admindashboard",
    icons: "mdi mdi-account-settings-variant",
    allowedRoles: [1],
    disabled: false
  },
  dashboard: {
    id: 1,
    title: "Doctor dashboard",
    link: "/dashboard",
    icons: "mdi mdi-pulse",
    allowedRoles: [2],
    disabled: false
  },
  frontdesk: {
    id: 32,
    title: "Frontdesk dashboard",
    link: "/dashboard",
    icons: "mdi mdi-pulse",
    allowedRoles: [3],
    disabled: false
  },

  // Doctor Documnet Page in sidebar
  // myfiles: {
  //   id: 20,
  //   title: "My Files",
  //   link: "/myfiles",
  //   icons: "mdi mdi-file-multiple",
  //   allowedRoles: [1, 2],
  //   disabled: false
  // },

  appointments: {
    id: 3,
    title: "Appointments",
    icons: "mdi mdi-calendar",
    allowedRoles: [1, 2],
    open: false,
    disabled: false,
    childrens: [
      {
        id: 38,
        title: "Attend",
        link: "/appointment/consultation",
        icons: "mdi mdi-calendar",
        allowedRoles: [1, 2],
        disabled: false,
      },
      {
        id: 4,
        title: "Requests",
        link: "/appointments/request",
        icons: "mdi mdi-calendar",
        allowedRoles: [1, 2, 3],
        disabled: false
      },
      {
        id: 5,
        title: "Schedule",
        link: "/appointments/schedule",
        icons: "mdi mdi-pulse",
        allowedRoles: [1, 2, 3],
        disabled: false
      },
      {
        id: 6,
        title: "Checkin",
        link: "/appointments/Checkin",
        icons: "mdi mdi-pulse",
        allowedRoles: [1, 2, 3],
        disabled: false
      },
      {
        id: 7,
        title: "Checkout",
        link: "/appointments/Checkout",
        icons: "mdi mdi-pulse",
        allowedRoles: [1, 2, 3],
        disabled: false
      },
    ],
  },

  fdeskappointments: {
    id: 3,
    title: "Appointments",
    icons: "mdi mdi-calendar",
    allowedRoles: [3],
    open: false,
    disabled: false,
    childrens: [
      {
        id: 4,
        title: "Requests",
        link: "/appointments/request",
        icons: "mdi mdi-calendar",
        allowedRoles: [1, 2, 3],
        disabled: false
      },
      {
        id: 5,
        title: "Schedule",
        link: "/appointments/schedule",
        icons: "mdi mdi-pulse",
        allowedRoles: [1, 2, 3],
        disabled: false
      },
      {
        id: 6,
        title: "Checkin",
        link: "/appointments/Checkin",
        icons: "mdi mdi-pulse",
        allowedRoles: [1, 2, 3],
        disabled: false
      },
      {
        id: 7,
        title: "Checkout",
        link: "/appointments/Checkout",
        icons: "mdi mdi-pulse",
        allowedRoles: [1, 2, 3],
        disabled: false
      },
    ],
  },

  adhocappt: {
    id: 20,
    title: "Adhoc Appointment",
    icons: "mdi mdi-clipboard-check",
    allowedRoles: [1, 2],
    disabled: false,
    open: false,
    childrens: [
      {
        id: 21,
        title: "Existing Patient",
        link: "/adhocappt/existing",
        allowedRoles: [1, 2],
        disabled: false
      },

      {
        id: 22,
        title: "New Patient",
        link: "/adhocappt/newpat",
        allowedRoles: [1, 2],
        disabled: false
      },
    ],
  },

  pathealthupdate: {
    id: 23,
    title: "Update Medical Records",
    link: "/pathealthupdate",
    icons: "mdi mdi-pen",
    allowedRoles: [1, 2],
    disabled: false
  },



  profile: {
    id: 8,
    title: "profiles",
    link: "/profile",
    icons: "mdi mdi-account-multiple-plus",
    allowedRoles: [1, 2],
    disabled: false
  },
  enroll_patient: {
    id: 9,
    title: "Patient Management",
    link: "/profile",
    icons: "mdi mdi-heart-pulse",
    allowedRoles: [3],
    disabled: false
  },
  extend_my_profile: {
    id: 10,
    title: "Extend my profile",
    link: "/expand-register",
    icons: "mdi mdi-account-convert",
    allowedRoles: [1],
    disabled: false
  },
  // services: {
  //   id: 11,
  //   title: "Services",
  //   link: "/org-srv",
  //   icons: "mdi mdi-format-list-bulleted-type",
  //   allowedRoles: [1, 3],
  //   disabled: false
  // },
  physicians: {
    id: 12,
    title: "Physicians",
    link: "/superadmin/physicians",
    icons: "mdi mdi-account-box-outline",
    allowedRoles: [5],
    disabled: false
  },
  patients: {
    id: 13,
    title: "Patients",
    link: "/superadmin/patients",
    icons: "mdi mdi-account-box-outline",
    allowedRoles: [5],
    disabled: false
  },
  appointment: {
    id: 19,
    title: "Appointments",
    link: "/superadmin/appointments",
    icons: "mdi mdi-account-box-outline",
    allowedRoles: [5],
    disabled: false
  },
  specialities: {
    id: 14,
    title: "Specialities",
    link: "/superadmin/specialities",
    icons: "mdi mdi-calendar-text",
    allowedRoles: [5],
    disabled: false
  },
  default_payout: {
    id: 15,
    title: "Default Payout",
    link: "/superadmin/default-payout",
    icons: "mdi mdi-calendar-text",
    allowedRoles: [5],
    disabled: false
  },

  coupons: {
    id: 16,
    title: "Coupons",
    icons: "mdi mdi-ticket-confirmation",
    allowedRoles: [5],
    open: false,
    disabled: false,
    childrens: [
      {
        id: 17,
        title: "Generate",
        link: "/superadmin/coupon-generate",
        allowedRoles: [5],
        disabled: false
      },
      {
        id: 18,
        title: "Search",
        link: "/superadmin/coupon-search",
        allowedRoles: [5],
        disabled: false
      },
    ],
  },

  physician_payout: {
    id: 33,
    title: "Physician Payout",
    link: "/superadmin/physician-payout",
    icons: "mdi mdi-account-box-outline",
    allowedRoles: [5],
    disabled: false
  },

  medicines: {
    id: 24,
    title: "Medicines",
    icons: "fa fa-medkit",
    allowedRoles: [5],
    open: false,
    disabled: false,
    childrens: [
      {
        id: 25,
        title: "Create",
        link: "/superadmin/medicine-create",
        allowedRoles: [5],
        disabled: false
      },
      {
        id: 26,
        title: "Search",
        link: "/superadmin/medicine-search",
        allowedRoles: [5],
        disabled: false
      },
    ],
  },

  prescr_templates: {
    id: 27,
    title: "Prescription Templates",
    icons: "mdi mdi-note",
    allowedRoles: [1, 2],
    open: false,
    disabled: false,
    childrens: [
      {
        id: 28,
        title: "Create",
        link: "/prescription/template-create",
        allowedRoles: [1, 2],
        disabled: false
      },
      {
        id: 29,
        title: "Search / Edit",
        link: "/prescription/template-edit",
        allowedRoles: [1, 2],
        disabled: false
      },
    ],
  },

  Services: {
    id: 30,
    title: "Services",
    icons: "mdi mdi-ticket-confirmation",
    allowedRoles: [1],
    open: false,
    disabled: false,
    childrens: [
      {
        id: 11,
        title: "Create Service",
        link: "/org-srv",
        icons: "mdi mdi-format-list-bulleted-type",
        allowedRoles: [1],
        disabled: false

      },
      {
        id: 31,
        title: "Service Reports",
        link: "/servicelist",
        allowedRoles: [1],
        disabled: false
      },
    ],
  },

  ServiceReports: {
    id: 34,
    title: "Create Service",
    link: "/org-srv",
    icons: "mdi mdi-format-list-bulleted-type",
    allowedRoles: [3],
    disabled: false
  },

  IllnessList: {
    id: 36,
    title: "Illness List",
    link: "/superadmin/illness-list",
    icons: "mdi mdi-format-list-bulleted",
    allowedRoles: [5],
    disabled: false
  },
  LabTest: {
    id: 37,
    title: "Lab Test",
    link: "/superadmin/labtest",
    icons: "mdi mdi-test-tube",
    allowedRoles: [5],
    disabled: false
  },



};

declare var $: any;
@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.css"],
})
export class SidebarComponent implements OnInit {
  user = new UsrCred();
  data: any;
  showComponent = true;
  menus: any = [];
  constructor(private loginService: VproService, private utils: Utils) { }

  ngOnInit() {
    this.data = JSON.parse(localStorage.getItem("LogUsrTyp"));
    console.log("From Login", this.data);
    // console.log("SIDE_MENUS", SIDE_MENUS);

    if (this.data && this.data.length) {
      for (let menu in SIDE_MENUS) {
        if (
          this.utils.checkRoutesAccess(this.data, SIDE_MENUS[menu].allowedRoles)
        ) {
          this.menus.push(Object.assign({}, SIDE_MENUS[menu]));
          if (this.data && this.data.length > 1) delete SIDE_MENUS.extend_my_profile;
        }
      }
      console.log(this.menus);

      // Disable Sidemenu Items
      if (localStorage.getItem("paid_account") === 'false') {
        for (let m of this.menus) {
          if (DISABLED_MENUS.includes(m.id)) {
            m.disabled = true
          }
          if (m.childrens) {
            for (let c of m.childrens) {
              if (DISABLED_MENUS.includes(c.id)) {
                c.disabled = true
              }
            }
          }
        }
      }
    }
    /* if (this.data && this.data.length > 1) {
      console.log("Extended"); //SIDE_MENUS2 .filter((item) => (item.indexOf('extend_my_profile') > -1)))

      for (let menu in SIDE_MENUS) {
        if (
          this.utils.checkRoutesAccess(this.data, SIDE_MENUS[menu].allowedRoles)
        ) {
          this.menus.push(Object.assign({}, SIDE_MENUS[menu]));
          delete SIDE_MENUS.extend_my_profile;
        }
      }
      console.log(this.menus);
    }

    if (this.data && this.data.length == 1) {
      console.log("Not");

      for (let menu in SIDE_MENUS) {
        if (
          this.utils.checkRoutesAccess(this.data, SIDE_MENUS[menu].allowedRoles)
        ) {
          this.menus.push(Object.assign({}, SIDE_MENUS[menu]));
        }
      }
      console.log(this.menus);
    } */
  }
  public _opened: boolean = true;

  public _toggleSidebar(): void {
    this._opened = !this._opened;
  }
  public _toggleSidebarClose(): void {
    this._opened = !this._opened;
  }
}